import { Select } from 'antd';
import mixpanel from 'mixpanel-browser';
import { getViewPage } from '@/utils/url';

// Antd defaults `showArrow={false}` on multi-select so chips can fill the
// trigger. We want the chevron everywhere by default to keep the trigger
// chrome consistent with single-select Selects across the app — flip the
// default at module load so callers don't have to opt in per usage.
Select.defaultProps = { ...Select.defaultProps, showArrow: true };

let route;

export function onRouteChange({ location /* , routes, action */ }) {
  // HACK: Fix to prevent sending duplicate events on refresh
  // Reported in issue: https://github.com/umijs/umi/issues/4752
  if (route === location.pathname) return;

  route = location.pathname;

  // Only track if Mixpanel has been initialized
  if (mixpanel.__loaded) {
    mixpanel.track('Page View', {
      page_url: window.location.href,
      view_page: getViewPage(location.pathname),
    });
  }
}
